<template>
    <div>
        <modal :show="show" :close="() => {}">
            <template v-slot:header>
                <h1 class="header">Generating Agreement</h1>
            </template>

            <template v-slot:body>
                <div class="body-text">Please wait while we generate your agreement for you to review.</div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"

    export default {
        name: "GeneratingAgreementModal",
        components: {
            Modal,
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>
